import React from "react"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {SizeProp} from "@fortawesome/fontawesome-svg-core"
import {IconName} from "@fortawesome/pro-regular-svg-icons"

import {iconGroup, IconNameExt} from "@utils/icons"


type CatIconProps = {
    icon: IconNameExt,
    iconSize?: SizeProp
}

function CatIcon({icon, iconSize}: CatIconProps) {

    if (iconGroup[icon] && iconGroup[icon] instanceof Array)
        return <span className="fa-layers fa-fw">
                   {iconGroup[icon].map(({icon, size, transform}, i) =>
                       <FontAwesomeIcon key={i} width={14}
                                        icon={icon} size={iconSize || size}
                                        transform={transform}/>)}
               </span>

    else
        return <FontAwesomeIcon width={14}
                                icon={["fal", icon as IconName || "crown"]}
                                size={iconSize || "2x"}
        />
}

export {CatIcon}

